module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_oliashirazi_sm-06fe3be1e0a5fa440d58031871d0950d.png";